<script>
export default {
	props: {
		showDialog: Boolean,
		images: Array,
		indexValue: Number,
	},
	model: {
		prop: 'indexValue',
		event: 'updateIndexValue',
	},
	data() {
		return {
			currentIndex: this.indexValue,
			mountCarousel: false,
		}
	},
	watch: {
		indexValue(value) {
			this.currentIndex = value
		},
		currentIndex(value) {
			this.$emit('updateIndexValue', value)
			this.$set(this.images[value], 'scale', 0)
		},
		showDialog(value) {
			setTimeout(() => (this.mountCarousel = value), 300)
		},
	},
	methods: {
		closeDialog() {
			this.$emit('closeDialog')
		},
		setImageScale(image) {
			let { scale = 0 } = image
			scale += 1
			if (scale > 2) scale = 0
			this.$set(image, 'scale', scale)
		},
	},
}
</script>

<template>
	<v-dialog :value="showDialog" persistent dark fullscreen transition="fade-transition">
		<div class="d-flex align-center justify-center overlay">
			<Button class="place-up" absolute top right icon x-large @click="closeDialog" dark>
				<v-icon x-large>mdi-close</v-icon>
			</Button>
			<Carousel
				v-if="mountCarousel"
				style="height: 100%"
				v-model="currentIndex"
				:items="images"
				:options="{
					arrows: { md: true },
					arrowsMargin: 40,
					arrowsInset: true,
					viewportStyle: 'height: 100%',
					duration: 0,
				}"
				:flicking-options="{ align: 'center', bound: true, threshold: 200 }"
			>
				<template #panel="{ item: image, active }">
					<div
						class="d-flex justify-center align-center py-4 img"
						style="height: 100%"
						:class="{ scale1: image.scale == 1, scale2: image.scale == 2, active }"
					>
						<Media
							:src="image.bigUrl"
							height="100%"
							max-width="100%"
							aspect-ratio="1"
							contain
							@click="setImageScale(image)"
						>
							<template #placeholder>
								<v-row class="fill-height ma-0" align="center" justify="center">
									<v-progress-circular indeterminate color="white" />
								</v-row>
							</template>
						</Media>
					</div>
				</template>
			</Carousel>
		</div>
	</v-dialog>
</template>

<style scoped>
.place-up {
	z-index: 999;
}
.overlay {
	background-color: rgba(0, 0, 0, 0.7);
	height: 100%;
}
.img {
	transform-origin: center;
	opacity: 0;
}
.img.active {
	opacity: 1;
}
.img.active.scale1 {
	transform: scale(1.2);
}
.img.active.scale2 {
	transform: scale(1.4);
}
</style>
